import { Gauge, Crosshair, Sparkles, Rocket, LineChart } from "lucide-react";
import { WHY_POINTS } from "@/lib/siteData";

const icons = [Gauge, Crosshair, Sparkles, Rocket, LineChart];

export const WhyDigibis = () => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <div className="text-xs tracking-[0.25em] uppercase font-bold text-[#E3A21A] mb-4">
              Why Digibis
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#F5F5F0] font-medium">
              Most agencies sell effort.
              <br />
              <span className="text-[#E3A21A]">We sell outcomes.</span>
            </h2>
            <p className="mt-6 text-[#A8B8A8] text-base leading-relaxed max-w-md">
              Five commitments that separate us from every "creative agency" pitch
              deck you've ever sat through.
            </p>
          </div>

          <div className="lg:col-span-7 space-y-4">
            {WHY_POINTS.map((w, i) => {
              const Icon = icons[i];
              return (
                <div
                  key={i}
                  data-testid={`why-item-${i}`}
                  className="group flex gap-6 p-6 md:p-7 rounded-2xl border border-[#E3A21A]/10 bg-[#1E2A1E]/50 hover:bg-[#1E2A1E] hover:border-[#E3A21A]/35 transition-all duration-300"
                >
                  <div className="flex-shrink-0">
                    <div className="h-12 w-12 rounded-xl bg-[#121A12] border border-[#E3A21A]/20 flex items-center justify-center text-[#E3A21A] group-hover:bg-[#E3A21A] group-hover:text-[#121A12] transition-colors duration-300">
                      <Icon className="h-5 w-5" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-baseline gap-3 mb-2">
                      <span className="font-mono text-xs text-[#A8B8A8]">
                        0{i + 1}
                      </span>
                      <h3 className="font-display text-xl md:text-2xl text-[#F5F5F0] tracking-tight font-medium">
                        {w.title}
                      </h3>
                    </div>
                    <p className="text-sm md:text-base text-[#A8B8A8] leading-relaxed">
                      {w.desc}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
